import { AgencyB2B } from "@/strapiQuery/agenciesB2B";

export type ContactFormValues = {
  agencySelected: AgencyB2B;
  socialReason: string;
  lastname: string;
  email: string;
  telephone: string;
  demand: string;
};

type ContactFormReponse = {
  ok: boolean;
  redirected: boolean;
  status: number;
  statusText: string;
  type: string;
  url: string;
};

export const sendContactFormValues = async (
  contactFormValues: ContactFormValues
): Promise<ContactFormReponse> => {
  return new Promise<ContactFormReponse>((resolve, reject) => {
    fetch(`api/send-email`, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify({
        agency: {
          name: contactFormValues.agencySelected.agencyName,
        },
        client: {
          email: contactFormValues.email,
          name: contactFormValues.lastname,
          company: contactFormValues.socialReason,
          message: contactFormValues.demand,
          phone: contactFormValues.telephone,
        },
      }),
    })
      .then((response: ContactFormReponse) => resolve(response))
      .catch((e) => reject(e));
  });
};
